import SceneManager from "./scene-manager";
import { elementHeight, getEl } from "../helpers";
import { ScrollCallback, ScrollDirection, ScrollHandler } from "./scroll-manager";
import anime, { AnimeInstance, AnimeParams } from "animejs";
import ResponsiveWatcher, {ResponsiveSize} from "./responsive-watcher";

export interface SceneAnimation {
	anim: AnimeInstance,
	playOnEnter: boolean,
}

export default class Scene implements ScrollHandler {

	/** Where on the screen/window does the scroll count from? 0 = Top of the window, 1 = Bottom of the window, 0.5 = Middle of the window.**/
	static WINDOW_OFFSET: number = 0;
	static WINDOW_OFFSET_MOBILE: number = 0.5;

	public elContainer: Element;
	public targetContainer: string;
	public inView: boolean;

	protected manager: SceneManager;
	public animations: SceneAnimation[] = [];

	constructor(manager: SceneManager, targetContainer: string) {
		this.manager = manager;
		this.targetContainer = targetContainer;

		this.elContainer = getEl(this.targetContainer);
	}


	public addScrollAnimation(anim: AnimeParams|AnimeInstance, containerElement: string|Element, smoothingTime: number = 500, scrollStart: number = 0, scrollEnd: number = 1, extraVhAbove: number = 0, extraVhBelow: number = 0, windowStartAt:number = 0.8)
	{
		return this.manager.app.scrolllocker.addScrollAnimation(
			anim, containerElement, smoothingTime,scrollStart, scrollEnd, extraVhAbove, extraVhBelow, windowStartAt
		);
	}

	public addAnimation(anim: AnimeParams, playOnEnter: boolean = true)
	{
		if ((playOnEnter) && !anim.autoplay) anim.autoplay = false;
		this.animations.push({
			anim: anime(anim),
			playOnEnter: playOnEnter,
		});
	}

	public onEnteredView(dir:ScrollDirection) {
		for (let i = 0; i < this.animations.length; i++)
		{
			if (this.animations[i].playOnEnter && !this.animations[i].anim.completed)
			{
				this.animations[i].anim.play();
			}
		}
	}

	public onExitedView(dir:ScrollDirection)
	{

	}

	public onScroll(direction: ScrollDirection, progress?: number, oldProgress?:number)
	{

	}

	public getHeight() {
		return elementHeight(this.elContainer);
	}

	public onResized() {

	}
	
	public onResponsiveChange(newSize:ResponsiveSize, oldSize:ResponsiveSize, responser: ResponsiveWatcher) {
	}

}
